import { render, staticRenderFns } from "./PatientSideCard.vue?vue&type=template&id=4d46c5aa&scoped=true&"
import script from "./PatientSideCard.vue?vue&type=script&lang=js&"
export * from "./PatientSideCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d46c5aa",
  null
  
)

export default component.exports